export const MAINURL = "https://loanbridge-backend-gamma.vercel.app";
